import { Base } from "ui/Scripts/source/framework/base";
import { CodeTitle, ICodeTitle } from "../common/codeTitle";
import { GroupPermission, IGroupPermission } from "../common/groupPermission";
import { GroupPermissionLevel } from "ui/Scripts/source/models/enums";

export interface ICompanyGroupPermissions {
    basePermission: GroupPermissionLevel;
    hasNormalCompanyGroups: boolean;
    hasFixedCompanyGroups: boolean;
    companyGroups: ICodeTitle[];
    permissions: IGroupPermission[];
    inheritedPermissions: IGroupPermission[];
}

export class CompanyGroupPermissions implements ICompanyGroupPermissions {
    basePermission: GroupPermissionLevel;
    hasNormalCompanyGroups: boolean;
    hasFixedCompanyGroups: boolean;
    companyGroups: CodeTitle[];
    permissions: GroupPermission[];
    inheritedPermissions: IGroupPermission[];

    constructor();
    constructor(obj: ICompanyGroupPermissions);
    constructor(obj?: any) {
        this.basePermission = obj && obj.basePermission || GroupPermissionLevel.None;
        this.hasNormalCompanyGroups = obj && obj.hasNormalCompanyGroups || false;
        this.hasFixedCompanyGroups = obj && obj.hasFixedCompanyGroups || false;
        this.companyGroups = Base.getTypedArray(obj ? obj.companyGroups : null, CodeTitle);
        this.permissions = Base.getTypedArray(obj ? obj.permissions : null, GroupPermission);
        this.inheritedPermissions = Base.getTypedArray(obj ? obj.inheritedPermissions : null, GroupPermission);
    }
}